import { PaymentFrequency } from '@willow/types-iso';

export const paymentFrequencyToAdjective = (paymentFrequency: PaymentFrequency): string | undefined => {
  switch (paymentFrequency) {
    case 1:
      return 'annual';
    case 12:
      return 'monthly';
    default:
      return undefined;
  }
};

export const paymentFrequencyToNoun = (paymentFrequency: PaymentFrequency): string | undefined => {
  switch (paymentFrequency) {
    case 1:
      return 'year';
    case 12:
      return 'month';
    default:
      return undefined;
  }
};
